import React from "react";

export function WorkflowIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <circle
        cx="3"
        cy="8"
        r="2"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        vectorEffect={vectorEffect}
      />
      <circle
        cx="13"
        cy="4"
        r="2"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        vectorEffect={vectorEffect}
      />
      <circle
        cx="13"
        cy="12"
        r="2"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        vectorEffect={vectorEffect}
      />
      <path
        d="M5 8H8L11 4"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M8 8L11 12"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
    </svg>
  );
}
